// extracted by mini-css-extract-plugin
module.exports = {"customers":"portfolio-module--customers--2aQmY","ssr":"portfolio-module--ssr--EaSB_"};